import { useState } from 'react';
import Heading from '@components/Heading/Heading';
import styles from '@features/cms/components/collections/DesignersBlock/DesignersBlock.styles';
import SingleDesigner from '@features/cms/components/collections/DesignersBlock/SingleDesigner';
import Icon from '@components/icons/Icon';
import theme from '@styles/theme';
import { IDesignerBlock } from '@features/cms/typescript';
import DesignerContent from '@features/cms/components/collections/DesignersBlock/DesignerContent';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  title: string;
  description: string;
  name: string;
  designers: IDesignerBlock[];
  isFirst: boolean;
};
const DesignerTeam = ({
  title,
  description,
  name,
  designers,
  isFirst
}: PropsType) => {
  const [designerSingleId, setDesignerSingleId] = useState<string>('');
  if (designers.length <= 1) return null;
  const handleOpenDesigner = (id: string) => {
    setDesignerSingleId(id);
  };
  const handleCloseDesigner = () => {
    setDesignerSingleId('');
  };
  return <div sx={styles.teamDesignerContainer}>
      <span sx={styles.designerNameText}>
        <Heading h={4} headingType={4}>
          {name}
        </Heading>
      </span>
      <DesignerContent title={title} description={description} isTeam isFirst={isFirst} />
      <div sx={styles.teamDesignersBlock}>
        <div sx={styles.teamDesignersBlockScroll}>
          {designers.map((designer: IDesignerBlock) => <button type="button" sx={styles.designerThumbnail(designers.length)} key={designer.itemId} onClick={() => handleOpenDesigner(designer.itemId)} data-testid={`designerThumbnail-${designer.itemId}`}>
              <ResponsiveImage image={typeof designer.thumbnail === 'string' ? designer.thumbnail : designer.thumbnail.path} alt={typeof designer.thumbnail !== 'string' ? designer.thumbnail.metadata.alt || designer.designerName : designer.designerName} />
              <span sx={styles.showDesignerIcon}>
                <Icon icon="Add2" size="24px" color={theme.rawColors.neutralWhite} />
              </span>
            </button>)}
        </div>
      </div>
      {designers.map((designer: IDesignerBlock) => <SingleDesigner key={designer.itemId} active={designerSingleId === designer.itemId} title={designer.designerName} image={{
      desktop: designer.image,
      mobile: designer.image,
      tablet: designer.image
    }} description={designer.description} thumbnail={designer.thumbnail.path} handleCloseDesigner={handleCloseDesigner} isTeam isFirst={false} />)}
    </div>;
};
export default DesignerTeam;